// import * as Highcharts from 'highcharts';
// import HC_fullscreen from 'highcharts/modules/full-screen.js';

// HC_fullscreen(Highcharts);
// import HC_exporting from 'highcharts/modules/exporting';

// HC_exporting(Highcharts);
// import HC_exportData from 'highcharts/modules/export-data';

// HC_exportData(Highcharts);
// import exporting from 'highcharts/modules/exporting';

// exporting(Highcharts);
// import HC_stock from 'highcharts/modules/stock';
// HC_stock(Highcharts);
import Highcharts from 'highcharts';


import { GraphUtils } from '@helpers/graph.helper';
import { Limit } from '@models/device';
import { ActivatedRoute, Route, Router } from '@angular/router';
import ExportDataModule from 'highcharts/modules/export-data';
import ExportingModule from 'highcharts/modules/exporting';

// Registra los módulos necesarios
if (typeof ExportDataModule === 'function') {
  ExportDataModule(Highcharts);
}

if (typeof ExportingModule === 'function') {
  ExportingModule(Highcharts);
}

export class Sensor {
  private router: Router = null;
  private redirectUrl: string = '';
  public limits: any = [];
  public isHide: boolean;
  public Highcharts: any = Highcharts;
  public colors: string[];
  public chartCallback: Highcharts.ChartCallbackFunction;
  public menuOptions: any[];
  public data: any[];

  constructor(router: Router, url: string, alerstActive: boolean) {
    this.router = router;
    this.redirectUrl = url;
    this.data = [];
    this.isHide = true;
    this.colors = ['#0075ff', '#48d57c', '#ffc400'];
    this.chartCallback = this._chartCallback;
    this.menuOptions = [
      'Ver en pantalla completa',
      'Imprimir gráfico',
      'Descargar en imagen PNG',
      'Descargar en imagen JPEG',
      'Descargar en archivo PDF',
      'Descargar en archivo CSV',
      'Descargar en archivo XLS',
      'Ver / Ocultar datos de tabla',
    ];
    const hasHardwareId = this.findParamInTree('hardwareId');


    if (alerstActive) {
      if (!hasHardwareId) {
        this.menuOptions.push('Añadir Límite');
        this.menuOptions.push('Añadir Rango');
      }
    }
  }
  /** Busca recursivamente un parámetro en todo el árbol de rutas */
  private findParamInTree(param: string): string | null {
    let node = this.router.routerState.snapshot.root;
    while (node) {
      const value = node.paramMap.get(param);
      if (value) {
        return value;
      }
      node = node.firstChild!;
    }
    return null;
  }


  public setData(item: any): void {
    this.isHide = false;
    this.data.push(item);
  }

  public setLimits(limits: Limit[]): void {
    this.limits = limits;
  }

  public showLegend(data) {
    return !!data;
  }

  public getConfigChar(id: string, series: any[], ranges?: any[], limits?: any[], graphType = 'line'): any {
    const softMax = GraphUtils.getMaxValue(series, ranges ?? [], limits ?? []);
    const softMin = GraphUtils.getMinValue(series, ranges ?? [], limits ?? []);

    const res = {
      id: id,
      title: {
        text: ''
      },
      xAxis: {
        type: 'datetime'
      },
      yAxis: {
        title: '',
        // softMax: softMax,
        // softMin: softMin,
        padding: 1,
        startOnTick: true,
        endOnTick: true
      },
      tooltip: {
        valueDecimals: 2,
      },
      chart: {
        zoomType: 'x',
        type: graphType,
        resetZoomButton: {
          position: {
            x: -30,
            y: -5,
          }
        },
      },
      legend: {
        enabled: true,
      },
      series: series,
      exporting: {
        enabled: true,
        filename: `${id}_export`,
        csv: {
          columnHeaderFormatter: (item) => (item.name || 'Sin nombre'),
        },

      },
      rangeSelector: {
        enabled: true,
        allButtonsEnabled: true,
        inputEnabled: true,
        buttons: [
          {
            type: 'day',
            count: 1,
            text: 'TD',
            title: 'View today',
            events: {
              click: () => {

                this.Highcharts.charts.forEach(chart => {
                  if (chart) {
                    if (chart.options.id == id) {
                      var lastDate = new Date(chart.xAxis[0].getExtremes().dataMax)
                      var startDate;

                      for (let i = series.length - 1; i >= 0; i--) {
                        var object: dataChart = series[i];
                        for (let j = object.data.length - 1; j >= 0; j--) {
                          startDate = new Date(object.data[j][0])
                          if (lastDate.getDate() != startDate.getDate()) {
                            break;
                          }
                        }
                      }

                      chart.xAxis[0].setExtremes(startDate.getTime(), lastDate.getTime(), false);
                      chart.redraw();
                    }
                  }
                })
              }
            }
          },
          {
            type: 'day',
            count: 1,
            text: 'YD',
            title: 'View yesterday',
            events: {
              click: () => {

                this.Highcharts.charts.forEach(chart => {
                  if (chart) {
                    if (chart.options.id == id) {
                      var lastDate = new Date(chart.xAxis[0].getExtremes().dataMax)
                      var yesterday = lastDate;
                      var startDate;

                      for (let i = series.length - 1; i >= 0; i--) {
                        var object: dataChart = series[i];
                        for (let j = object.data.length - 1; j >= 0; j--) {
                          startDate = new Date(object.data[j][0]);
                          if (yesterday == lastDate && lastDate.getDate() != startDate.getDate() && j != object.data.length - 1) {
                            yesterday = new Date(object.data[j + 1][0]);
                          }
                          if ((yesterday != lastDate) && (yesterday.getDate() > startDate.getDate())) {
                            break;
                          }
                        }
                      }

                      chart.xAxis[0].setExtremes(startDate.getTime(), yesterday.getTime(), false);
                      chart.redraw();
                    }
                  }
                })
              }
            }
          },
          {
            type: 'day',
            count: 7,
            text: '7d',
            title: 'Seven days'
          },
          {
            type: 'month',
            count: 1,
            text: '1m',
            title: 'One month'
          },
          {
            type: 'month',
            count: 3,
            text: '3m',
            title: 'Three months'
          },
          {
            type: 'month',
            count: 6,
            text: '6m',
            title: 'Six months'
          },
          {
            type: 'year',
            count: 1,
            text: '1y',
            title: 'One year'
          },
          {
            type: 'ytd',
            text: 'YTD',
            title: 'View year to date'
          },
          {
            type: 'all',
            text: 'All',
            title: 'All'
          }],
        selected: 2
      },
    };

    if (ranges && ranges.length > 0) {
      res['yAxis']['plotBands'] = ranges;
    }

    if (limits && limits.length > 0) {
      res['yAxis']['plotLines'] = limits;
    }

    return res;
  }

  public static getVariables(): any[] {
    return null;
  }

  selectOption(i: number, id: string) {
    switch (i) {
      case 0:
        this.fullscreen(id.toLowerCase())
        break;
      case 1:
        this.printChart(id.toLowerCase());
        break;
      case 2:
        this.downloadPNG(id.toLowerCase());
        break;
      case 3:
        this.downloadJPEG(id.toLowerCase());
        break;
      case 4:
        this.downloadPDF(id.toLowerCase());
        break;
      case 5:
        this.downloadCSV(id.toLowerCase());
        break;
      case 6:
        this.downloadXLS(id.toLowerCase());
        break;
      case 7:
        this.viewData(id.toLowerCase());
        break;
      case 8:
        this.gotToNewLimit();
        break;
      case 9:
        this.gotToNewRange();
        break;
      default:
        break;
    }
  }

  gotToNewLimit(): void {
    this.router.navigate(
      [this.redirectUrl],
      { queryParams: { mode: 'limit' } }
    );
  }

  gotToNewRange(): void {
    this.router.navigate(
      [this.redirectUrl],
      { queryParams: { mode: 'range' } }
    );
  }

  printChart(id: string) {
    this.Highcharts.charts.forEach(chart => {
      if (chart) {
        if (chart.options.id.toLowerCase() == id.toLowerCase()) {
          chart.print();
        }
      }
    })
  }

  fullscreen(id: string) {
    this.Highcharts.charts.forEach(chart => {
      if (chart) {
        if (chart.options.id.toLowerCase() == id.toLowerCase()) {
          chart.fullscreen.open();
        }
      }
    })
  }

  downloadJPEG(id: string) {
    this.Highcharts.charts.forEach(chart => {
      if (chart) {
        if (chart.options.id.toLowerCase() == id.toLowerCase()) {
          chart.exportChart({ type: 'image/jpeg', filename: 'highchart' }, null);
        }
      }
    })
  }

  downloadPNG(id: string) {
    this.Highcharts.charts.forEach(chart => {
      if (chart) {
        if (chart.options.id.toLowerCase() == id.toLowerCase()) {
          chart.exportChart({ type: 'image/png', filename: 'highchart' }, null)
        }
      }
    })
  }

  downloadPDF(id: string) {
    this.Highcharts.charts.forEach(chart => {
      if (chart) {
        if (chart.options.id.toLowerCase() == id.toLowerCase()) {
          chart.exportChart({ type: 'application/pdf', filename: 'highchart' }, null)
        }
      }
    })
  }

  downloadCSV(id: string) {
    this.Highcharts.charts.forEach(chart => {
      if (chart) {
        if (chart.options.id.toLowerCase() == id.toLowerCase()) {
          chart.downloadCSV();
        }
      }
    })
  }

  downloadXLS(id: string) {
    this.Highcharts.charts.forEach(chart => {
      if (chart) {
        if (chart.options.id.toLowerCase() == id.toLowerCase()) {
          chart.downloadXLS();
        }
      }
    })
  }

  viewData(id: string) {
    this.Highcharts.charts.forEach(chart => {
      if (chart) {
        if (chart.options.id.toLowerCase() == id.toLowerCase()) {
          if (!chart.options.exporting.showTable) {
            chart.options.exporting.showTable = true;
            chart.viewData();
          } else {
            chart.options.exporting.showTable = false;
            chart.hideData();
          }
        }
      }
    })
  }

  public reloadCharts() {
    if (!this.isHide) {
      this.Highcharts.charts.forEach(chart => {
        setTimeout(() => {
          if (chart) {
            chart.reflow();
          }
        });
      }, 1000);
    }
  }

  public loadTabEventListener() {
    const that = this;
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) {
        that.reloadCharts();
      }
    });
  }

  private _chartCallback(chart): void {
    setTimeout(() => {
      if (chart) {
        chart.redraw();
        chart.reflow();
      }
    }, 1000);
  }

  protected getChartSeries(name: string, data: any[]): any {
    const series = [];
    data.forEach((s, index) => {
      series.push({
        name: `${name}${index + 1}`,
        data: GraphUtils.bubleSort(s),
        color: this.colors[index],
        showInLegend: this.showLegend(s)
      });
    });

    return series;
  }

  protected getChartSeriesNewNode(name: string, data: any[], positionNode: any[]): any {
    const series = [];
    data.forEach((s, index) => {
      const positionSensor = positionNode[index];
      series.push({
        name: `${name} ${positionSensor}`,
        data: GraphUtils.bubleSort(s),
        color: this.colors[index],
        showInLegend: this.showLegend(s)
      });
    });

    return series;
  }

  protected getRanges(property: string): any[] {
    const ranges = [];
    let listRanges = this.limits.filter((l) => l.isVisible && l.property == property && l.type == 1);

    for (const lr of listRanges) {
      const range = {
        label: {
          text: lr.name,
        },
        color: lr.colorCode,
        from: lr.minValue,
        to: lr.maxValue
      }

      ranges.push(range);
    }

    return ranges;
  }

  protected getLimits(property: string): any[] {
    const limits = [];
    let listLimits = this.limits.filter((l) => l.isVisible && l.property == property && l.type == 0);

    for (const lr of listLimits) {
      const limit = {
        label: {
          text: lr.name,
        },
        color: lr.colorCode,
        value: lr.value,
        zIndex: 3
      }

      limits.push(limit);
    }

    return limits;
  }
}

export interface dataChart {
  name: string,
  data: [],
  color: string,
  showInLegend: boolean
}